import { useIntl } from "react-intl";

const AdminInsights = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "ConfluencePricingPage.features.AdminInsights.header",
            defaultMessage: "Admin insights"
        }),
        content: intl.formatMessage({
            id: "ConfluencePricingPage.features.AdminInsights.content",
            defaultMessage:
                "Confluence mission control allows product admins to quickly and easily access site-level insights and controls – all in one place. This includes a snapshot into overall site health and activity, providing greater oversight and management of Confluence site and spaces."
        }),
        altText: intl.formatMessage({
            id: "ConfluencePricingPage.features.AdminInsights.altText",
            defaultMessage: "Example of admin insights"
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.content}</p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/MissionControl.webp"
                alt={messages.altText}
                height={350}
                loading="lazy"
            />
        </>
    );
};

export default AdminInsights;
